import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { GlobalHelper } from '../utils/GlobalHelper';
import { SessionActions } from './SessionActions';
import { AppHelper } from '../utils/AppHelper';
import { PersistentStore, SortType } from '../stores/PersistentStore';

export abstract class PersistentActions {
    public static acceptCookie(value: 'true' | 'false'): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.ACCEPT_COOKIE,
            value: value
        });
    }

    public static setProjectSortType(sortType: SortType): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_PROJECTS_SORT,
            value: sortType
        });
    }

    public static setImageFormat(filetype: string): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_IMAGE_FORMAT,
            value: filetype
        });
    }

    public static setImageTransparent(transparent: string): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_IMAGE_TRANSPARENT,
            value: transparent
        });
    }

    public static setLanguage(language: string): void {
        GlobalHelper.setLanguage(language);
        SessionActions.setLocale(language);
        AppHelper.setLanguage(language).then(
            () => {
                if (language !== PersistentStore.getState().language) {
                    AppDispatcher.dispatch({
                        actionType: ActionConstants.SET_LANGUAGE,
                        value: language
                    });
                }
            },
            () => { /* */ }
        );
    }

    public static toggleSidebarPosition(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_SIDEBAR_POSITION,
            value: PersistentStore.getState().sidebarPosition === 'left' ? 'right' : 'left'
        });
    }

    public static setRightSidebarPosition(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_SIDEBAR_POSITION,
            value: 'right'
        });
    }

    public static setLeftSidebarPosition(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_SIDEBAR_POSITION,
            value: 'left'
        });
    }

    public static setAutoSaveId(value: string): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_AUTOSAVE_ID,
            value: value
        });
    }

    public static hidePrices(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_PRICE_VISIBLITY,
            value: 'hide'
        });
    }

    public static showPrices(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_PRICE_VISIBLITY,
            value: 'show'
        });
    }

    public static hideBanner(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.HIDE_BANNER,
            value: null
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/PersistentActions.ts